import { type DateObject, type FeedActivity } from '@capsicum/common';

export enum PostTypes {
	BO_FORM = 'backoffice_form',
	COLLECTIBLE_AUCTION = 'collectible_auction_published',
	GAMIFICATION_FORM = 'gamification_form',
	PARTNER_NEWS_ARTICLE = 'wp_news_post_published',
	SURVEY_ENGAGEMENT_POLL = 'survey_engagement_poll',
	SURVEY_INTEGRITY_POLL = 'survey_integrity_poll',
	USER_ACQUIRED_FAN_TOKEN = 'user_first_fan_token_acquisition',
	USER_FANSHOP_REWARD = 'user_fanshop_reward',
	USER_POLL_VOTE_RESULT = 'poll_result_set',
	USER_VOTED_ON_SURVEY_ENGAGEMENT_POLL = 'user_voted_on_survey_engagement_poll',
	USER_VOTED_ON_SURVEY_INTEGRITY_POLL = 'user_voted_on_survey_integrity_poll',
	WP_IMAGE_TYPE = 'wp_image_published',
	WP_IMAGE_TYPE_POLL = 'wp_image_published_poll',
	WP_IMAGE_TYPE_TYPEFORM = 'wp_image_published_typeform'
}

export type PostActivityType = {
	activityId: string;
	actor: PostActor;
	expireAt: DateObject | null;
	object: ObjectDataShape;
	time: DateObject;
	verb: PostTypes;
};

export type PostActor = {
	id: string;
	image: string;
	name: string;
	shortName: string;
	type: string;
};

export type ObjectDataShape = Exclude<FeedActivity['object'], undefined>;

export type FetchMeActivities<T> = {
	data: Array<T>;
	metadata: ActivityMetadata;
};

export type ActivityMetadata = {
	nextOffset: number;
	references: string;
	time: string;
};
